/**
 * Created : vincent
 * Date : 2017/4/24  下午3:32
 * Email : wangxiao@wafersystems.com
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import RegionalMaintenanceTree from './RegionalMaintenanceTree';
import { Button, message, Modal } from 'antd';

class RegionalMaintenance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMap: new Map(),
      save: false,
      isEdit: false
    };
    this.editHandle = this.editHandle.bind(this);
    this.saveChange = this.saveChange.bind(this);
    this.cancelEditHandle = this.cancelEditHandle.bind(this);
    this.editEditFlag = this.editEditFlag.bind(this);
  }

  editHandle(node, value) {
    this.state.editMap.set(node, value);
    this.setState({
      editMap: this.state.editMap,
      save: true,
      isEdit: true
    });
  }

  cancelEditHandle(node) {
    this.state.editMap.delete(node);
    this.setState({
      isEdit: false
    });
  }
  editEditFlag(value) {
    this.setState({isEdit: value});
  }
  saveChange() {
    const { dispatch, intl } = this.props;
    for (let key of this.state.editMap.keys()) {
      const value = this.state.editMap.get(key);
      if (value.length < 1 || value.length > 50) {
        Modal.error({ content: intl.formatMessage({ id: 'regional_maintenance_edit_tip_placeholder' }) });
        return;
      }
    }
    for (let key of this.state.editMap.keys()) {
      const value = this.state.editMap.get(key);
      const data = {
        locale: intl.locale,
        id: !key.hasOwnProperty('parId') ? '' : key.id,
        parName: key.parentName,
        sonName: value
      };
      if (key.hasOwnProperty('parId')) {
        dispatch({ type: 'account/updateZone', data: data });
      } else {
        dispatch({ type: 'account/saveZone', data: data });
      }
    }
    this.setState({
      save: false,
      isEdit: false
    });
    this.state.editMap = new Map();
  }

  render() {
    const { dispatch, intl } = this.props;
    return (
      <div className="area_tree_div">
        <div className="left_head">
          {/*<span><FormattedMessage id="room_manage_list"/></span>*/}
          <div className="area_btn_div">
            {this.state.editMap.size !== 0 && (
              <Button
                type="primary"
                className="area_btn"
                onClick={this.saveChange}
              >
                <FormattedMessage id="reservation_save" />
              </Button>
            )}
            {this.state.editMap.size == 0 && (
              <Button
                icon="plus"
                type="primary"
                className="area_btn"
                style={{backgroundColor:'#4680FF',borderColor:'#4680FF'}}
                onClick={() => {
                  if(this.state.isEdit == true) {
                    message.info(intl.formatMessage({id: 'account_zone_add_value1'}));
                    return;
                  }
                  this.setState({
                    isEdit: true
                  });
                  dispatch({ type: 'account/addAreaNode' });
                }}
              >
                <FormattedMessage id="new_regional_maintenance" />
              </Button>
            )}
          </div>
        </div>
        <div className="left_tree">
          <div className="area_border">
            <RegionalMaintenanceTree
              {...this.props}
              titleState={this.props.titleState}
              ref={a => (this._a = a)}
              editHandle={this.editHandle}
              cancelEditHandle={this.cancelEditHandle}
              save={this.state.save}
              isEdit={this.state.isEdit}
              editEditFlag={this.editEditFlag}
            />
          </div>
        </div>
      </div>
    );
    // return (
    //   <Collapse defaultActiveKey="2" activeKey="2">
    //     <Panel header={<div><span><FormattedMessage id="regional_maintenance_title"/></span>
    //       <div className="title-btn re-show">
    //         {this.state.editMap.size !== 0 &&
    //         <button onClick={this.saveChange}><FormattedMessage
    //           id="reservation_save"/>
    //         </button>
    //         }
    //         < button onClick={() => {
    //           dispatch({type:'account/addAreaNode'})
    //         }}>+<FormattedMessage id="new_regional_maintenance"/></button>
    //       </div>
    //     </div>} key="2">
    //     </Panel>
    //   </Collapse>
    // )
  }
}

export default RegionalMaintenance;



// WEBPACK FOOTER //
// ./src/components/account/RegionalMaintenance.js